export const setAvatarsAndUsers = resp => {
  return {
    type: "FETCH_AVATARS_AND_USERS",
    payload: resp
  };
};

export const setUsers = (resp, operation) => {
  if (operation === "pushUsersForSettings") {
    return {
      type: "PUSH_USERS",
      payload: resp
    };
  }
  return {
    type: "FETCH_USERS",
    payload: resp
  };
};

export const saveUsers = resp => {
  return {
    type: "SAVE_USERS",
    payload: resp
  };
};

export const saveUserAvatar = resp => {
  return {
    type: "SAVE_USER_AVATAR",
    payload: resp
  };
};

export const initUsers = () => {
  return {
    type: "INIT_USERS"
  };
};

export const updateUsers = payload => {
  return {
    type: "UPDATE_USERS",
    payload
  };
};

export const initSaveUsers = () => {
  return {
    type: "INIT_SAVE_USERS"
  };
};

export const initSaveUserAvatar = () => {
  return {
    type: "INIT_SAVE_USER_AVATAR"
  };
};

export const saveGeneralSettings = resp => {
  return {
    type: "SAVE_GENERAL_SETTINGS",
    payload: resp
  };
};

export const updateGeneralSettings = payload => {
  return {
    type: "UPDATE_GENERAL_SETTINGS",
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/user.js